import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { AuctionStatusName } from '../../constants/AuctionStatus';
import { dateToString } from '../../common/utils/date/Date.utils';
import { AuctionStatusTypeName } from '../../constants/AuctionStatusType';
import editIcon from '../../assets/img/icons/edit-primary.svg';
import { preparePriceFormat } from '../../helpers/preparePriceFormat';
import { formatOrganizationLocation } from '../../helpers/formatOrganizationLocation';
import { pencesToPounds } from '../../common/helpers/pencesToPounds';
import copyIcon from '../../assets/img/icons/copy.svg';
import { showAlert } from '../../common/components/alert/AlertActions';
import AlertVariant from '../../common/components/alert/AlertVariant';

function VehiclesTableRow({ item }) {
  const {
    id,
    vehicle,
    launchedOn,
    type,
    status,
    buyer,
    buyerLocation,
    seller,
    location,
    launchingCounterSerial,
    endsOn,
  } = item;

  const dispatch = useDispatch();

  const title = `${vehicle?.vehicleModel?.makeName} ${vehicle?.vehicleModel?.name} | ${vehicle?.year}`;
  const sellerFullName = `${seller?.firstName} ${seller?.lastName}`;
  const vehicleCapClean = preparePriceFormat(pencesToPounds(vehicle.vehicleCapClean * 100));

  const handleCopyAuctionLink = (e) => {
    e.stopPropagation();
    const dealerWebsite = process.env.REACT_APP_DEALER_URL;
    if (!dealerWebsite || !id) return;
    navigator.clipboard
      .writeText(`${dealerWebsite}/auction/${id}`)
      .then(() =>
        dispatch(showAlert('Auction link copied to clipboard', AlertVariant.SUCCESS)),
      )
      .catch(() =>
        dispatch(showAlert('Could not copy the link. Please try again.', AlertVariant.DANGER)),
      );
  };

  return (
    <>
      <td>{vehicle?.registrationPlate}</td>
      <td>{title}</td>
      <td>{dateToString(vehicle?.dateOfFirstRegistration)}</td>
      <td>{vehicleCapClean ?? '-'}</td>
      <td>{launchedOn ? dateToString(launchedOn) : '-'}</td>
      <td>{endsOn ? dateToString(endsOn) : '-'}</td>
      <td>{AuctionStatusTypeName?.[type]}</td>
      <td>{buyer?.organizationContact?.tradeName ?? '-'}</td>
      <td>{formatOrganizationLocation(buyerLocation) || '-'}</td>
      <td>{seller?.organizationContact?.tradeName}</td>
      <td>{formatOrganizationLocation(location) || '-'}</td>
      <td>{sellerFullName}</td>
      <td>{AuctionStatusName?.[status].toUpperCase()}</td>
      <td>{launchingCounterSerial}</td>
      <td className="text-right">
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip-edit-${id}`}
          size="sm"
          type="button"
        >
          <img src={editIcon} alt="Edit icon" />
        </Button>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`tooltip-edit-${id}`}
        >
          Edit
        </UncontrolledTooltip>
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          size="sm"
          type="button"
          onClick={handleCopyAuctionLink}
        >
          <img width={22} height={22} src={copyIcon} alt="Copy icon" />
        </Button>
      </td>
    </>
  );
}

export default VehiclesTableRow;
